/* eslint-disable @typescript-eslint/no-explicit-any */
import { filter, get, head, isNil, map } from 'es-toolkit/compat';

export function firstNonNil(arr: any) {
  return head(filter(arr, (el: any) => !isNil(el)));
}

export function firstNonNilProperty<T>(obj: T, arrOfPropertyAccessors: (keyof T)[]) {
  return firstNonNil(map(arrOfPropertyAccessors, (path: keyof T) => get(obj, path)));
}
